import React, { useRef, useState } from "react";
import { Form, Input, Button, message } from "antd";
import { postRequest } from "../Auth/api";
import "./otpverify.css";
import { useNavigate } from "react-router-dom";

const OtpVerify = () => {
  const navigate = useNavigate();
  const email = localStorage.getItem("registeredEmail");
  const [timer, setTimer] = useState(120); // 2 minutes
  const [resendAllowed, setResendAllowed] = useState(false);
  const [loading, setLoading] = useState(false);
  const countdownRef = useRef(null); // To control the interval globally

  // Start or restart the countdown
  const startCountdown = () => {
    setTimer(120);
    setResendAllowed(false);
    clearInterval(countdownRef.current);
    countdownRef.current = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(countdownRef.current);
          setResendAllowed(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  // useEffect(() => {
  //   // if (!email) {
  //   //   message.error("Email not found. Redirecting to register.");
  //   //   navigate("/register");
  //   // }
  //   startCountdown(); // Start countdown on mount
  //   return () => clearInterval(countdownRef.current); // Cleanup
  // }, [email, navigate]);

  const formatTime = () => {
    const min = Math.floor(timer / 60);
    const sec = timer % 60;
    return `${min}:${sec < 10 ? "0" : ""}${sec}`;
  };

  const handleVerify = async (values) => {
    setLoading(true);
    try {
      const res = await postRequest("verify-email-otp", {
        email,
        otp: values.otp,
      });
      message.success("OTP verified successfully!");
      localStorage.removeItem("registeredEmail");
      navigate("/login");
      console.log(res);
    } catch (err) {
      message.error(err.message || "Verification failed.");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    try {
      if (!email) throw new Error("Email not found.");
      await postRequest("resend-otp", { email });
      message.success("OTP resent successfully!");
      startCountdown(); // Restart timer
    } catch (err) {
      message.error(err.message || "Failed to resend OTP.");
    }
  };

  return (
    <div className="otp-container">
      <div className="otp-box">
        <h2>Email Verification</h2>
        <p className="enter-text">Enter the 6-digit OTP sent to</p>
        <p className="email-text">
          <strong>{email}</strong>
        </p>

        <Form onFinish={handleVerify}>
          <Form.Item
            name="otp"
            rules={[
              { required: true, message: "Please enter the OTP" },
              { len: 6, message: "OTP must be 6 digits" },
            ]}
          >
            <Input placeholder="Enter OTP" maxLength={6} />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              className="verify-btn"
            >
              Verify OTP
            </Button>
          </Form.Item>
        </Form>

        <p className="otp-timer">
          {timer > 0 ? `OTP valid for: ${formatTime()}` : "OTP expired."}
        </p>

        <Button
          type="link"
          onClick={handleResend}
          disabled={!resendAllowed}
          block
        >
          Resend OTP
        </Button>
      </div>
    </div>
  );
};

export default OtpVerify;
